<template>
  <div class="popular-streams-container">
    <div class="streams-content">
      <div class="streams-header">
        <!-- タイトル -->
        <div class="streams-title">{{ $t('historiesMostViewedBroadcast') }}</div>
      </div>

      <!-- 配信リスト -->
      <div class="streams-list">
        <div 
          v-for="(stream, index) in streamsList" 
          :key="index" 
          class="stream-item"
        >
          <div class="stream-info">
            <div class="stream-title">{{ stream.title }}</div>
            <div class="stream-date">{{ stream.date }}</div>
          </div>
          <!-- 区切り線（最後以外） -->
          <div 
            v-if="index < streamsList.length - 1"
            class="divider-line"
          >
            <svg class="divider-svg" viewBox="0 0 311 2" fill="none">
              <path
                d="M0 1H311"
                stroke="white"
                stroke-width="1"
                opacity="0.5"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import { HistoryAlbumKeyedData } from '@/api/pb/HistoryAlbum/Common/HistoryAlbumKeyedData'
import { HistoryAlbumUser } from '@/api/pb/HistoryAlbum/Common/HistoryAlbumUser'
import { formatDate } from '@/pages/campaign/reality_histories_20m/util'

interface Broadcast {
  title: string
  date: string
}

@Component({})
export default class PopularBroadcasts extends Vue {
  @Prop({ type: Number, required: true })
  year!: number

  // 年別データをpropsで受け取る
  @Prop({ type: Object, default: null })
  yearData!: HistoryAlbumKeyedData | null

  // ユーザー情報をpropsで受け取る
  @Prop({ type: Object, default: null })
  user!: HistoryAlbumUser | null

  // 配信リスト（実際のデータから取得）
  get streamsList(): Broadcast[] {
    if (!this.yearData || !this.yearData.broadcastRecords) {
      return []
    }

    // データはすでにソートされているのでそのまま使用
    return this.yearData.broadcastRecords
      .filter(record => record.liveName && record.liveDate) // 必要なデータが存在するもののみフィルタ
      .map(record => ({
        title: record.liveName,
        date: formatDate(record.liveDate!)
      }))
  }

}
</script>

<style scoped>
.popular-streams-container {
  position: relative;
  width: 100%;
  border-radius: 8px;
  background: linear-gradient(117deg, #DC7EFF 0%, #8CAAFD 100%);
  overflow: hidden;
}

/* 背景のLIVEテキスト */
.popular-streams-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 220px;
  height: 50px;
  background-image: url('/img/campaign/reality_histories_20m/img_text_live.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left top;
  opacity: 1;
  z-index: 1;
}

/* 背景のLIVEアイコン */
.popular-streams-container::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 120px;
  height: 120px;
  background-image: url('/img/campaign/reality_histories_20m/img_live.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right top;
  opacity: 1;
  z-index: 1;
}

.streams-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 32px 16px 16px 16px;
  position: relative;
  width: 100%;
  z-index: 2;
}

/* ヘッダー */
.streams-header {
  position: relative;
  width: 100%;
}

.streams-title {
  font-weight: 600;
  font-style: normal;
  font-size: 26px;
  color: #ffffff;
  text-align: left;
  white-space: nowrap;
  line-height: normal;
  position: relative;
  z-index: 3;
}

/* 配信リスト */
.streams-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0;
  position: relative;
  width: 100%;
}

.stream-item {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0;
  position: relative;
  width: 100%;
}

.stream-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  line-height: 0;
  font-style: normal;
  padding: 0;
  color: #ffffff;
  text-align: left;
  width: 100%;
}

.stream-title {
  font-weight: 600;
  position: relative;
  flex-shrink: 0;
  font-size: 16px;
  width: 100%;
  line-height: normal;
  margin-bottom: 4px;
}

.stream-date {
  font-weight: 300;
  position: relative;
  flex-shrink: 0;
  font-size: 11px;
  width: 100%;
  line-height: normal;
}

/* 区切り線 */
.divider-line {
  position: relative;
  flex-shrink: 0;
  width: 100%;
}

.divider-svg {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
